import { breakpoints } from "./Picture.media";
export function imageDprsToPictureSources(images) {
    return images.map(image => {
        return {
            srcSet: `${image.x1}${image.x2 ? `, ${image.x2} 2x` : ""}`,
            minWidth: breakpoints[image.size],
            placeholderUrl: image.placeholderUrl,
        };
    });
}
export function getPicture(image) {
    return {
        sources: imageDprsToPictureSources(image.sizes),
        fallback: {
            src: image.fallback.x1,
            placeholderUrl: image.fallback.placeholderUrl,
        },
        altText: image.altText,
    };
}
export function getImageUrl(image, width, height, crop, resizeFill) {
    if (crop && width && height) {
        return image.crop(width, height, crop).quality(100).url();
    }
    return image.resize(width, height, resizeFill).quality(100).url();
}
export function getPlaceholderUrl(image, placeholderConfig) {
    return image.placeholder(placeholderConfig).url();
}
export function getImage(image, imageInputConfig, placeholderConfig, altText, caption) {
    const fallback = imageInputConfig.fallback;
    const x1Fallback = fallback.crop
        ? image.crop(fallback.width, fallback.height, fallback.crop)
        : image.resize(fallback.width, fallback.height, fallback.resizeFill);
    const isFliteImage = image.isFliteImage();
    return {
        sizes: imageInputConfig.sources.map((imageInput) => {
            const x1Image = imageInput.crop
                ? image.crop(imageInput.width, imageInput.height, imageInput.crop)
                : image.resize(imageInput.width, imageInput.height, imageInput.resizeFill);
            return {
                size: imageInput.size,
                x1: x1Image.quality(100).url(),
                x2: getImageUrl(image, imageInput.width * 2, imageInput.height * 2, imageInput.crop, imageInput.resizeFill),
                placeholderUrl: getPlaceholderUrl(isFliteImage ? x1Image : image, placeholderConfig),
            };
        }),
        fallback: {
            size: imageInputConfig.fallback.size,
            x1: x1Fallback.quality(100).url(),
            x2: getImageUrl(image, imageInputConfig.fallback.width * 2, imageInputConfig.fallback.height * 2, imageInputConfig.fallback.crop, imageInputConfig.fallback.resizeFill),
            placeholderUrl: getPlaceholderUrl(isFliteImage ? x1Fallback : image, placeholderConfig),
        },
        altText,
        caption,
    };
}
